export const ClientsDocsIcon = ({ className }) => {
  return (
    <svg
      width={80}
      height={80}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_9743_7894)">
        <path
          d="M62.5 70H17.5C16.837 70 16.2011 69.7366 15.7322 69.2678C15.2634 68.7989 15 68.163 15 67.5V12.5C15 11.837 15.2634 11.2011 15.7322 10.7322C16.2011 10.2634 16.837 10 17.5 10H47.5L65 27.5V67.5C65 68.163 64.7366 68.7989 64.2678 69.2678C63.7989 69.7366 63.163 70 62.5 70Z"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.5 10V27.5H65"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.4076 49.7272C44.0099 49.7272 47.7409 45.9827 47.7409 41.3636C47.7409 36.7445 44.0099 33 39.4076 33C34.8052 33 31.0742 36.7445 31.0742 41.3636C31.0742 45.9827 34.8052 49.7272 39.4076 49.7272Z"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.9102 56.0002C28.3656 54.0526 30.2528 52.4718 32.4224 51.3831C34.5921 50.2944 36.9845 49.7275 39.4102 49.7275C41.8359 49.7275 44.2283 50.2944 46.3979 51.3831C48.5675 52.4718 50.4547 54.0526 51.9102 56.0002"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9743_7894">
          <rect width={80} height={80} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
